require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-tyler-morgan.json") })
        }
      }, "path---blog-author-tyler-morgan");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-tyler-morgan!./.cache/json/blog-author-tyler-morgan.json
// module id = 712
// module chunks = 231608221292675